export default __webpack_public_path__ + "static/media/LINK-BNB.e4cab91a.svg";